module.exports = __webpack_public_path__ + "static/media/course.63579270.jpg";